(function () {
  'use strict';
  var cfg = window.themeConfig || {};

  function money(cents, format) {
    format = format || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount';
    function n(dec, thou, dp) {
      var s = (cents / 100).toFixed(dec).split('.');
      return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou) + (s[1] ? dp + s[1] : '');
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = n(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = n(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = n(0, '.', ','); break;
      case 'amount_with_space_separator': v = n(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = n(0, ' ', '.'); break;
      default: v = n(2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function updateCartCount() {
    return fetch(cfg.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  function initGallery(root) {
    if (root._i) return; root._i = 1;
    var main = root.querySelector('[data-gallery-main]');
    if (!main) return;
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () { showMedia(root, b.getAttribute('data-thumb')); });
    });
  }
  function showMedia(root, id) {
    var item = root.querySelector('[data-media-id="' + id + '"]');
    var main = root.querySelector('[data-gallery-main]');
    if (item && main) main.scrollTo({ left: item.offsetLeft - main.offsetLeft, behavior: 'smooth' });
  }

  function initProduct(box) {
    if (box._i) return; box._i = 1;
    var variants = JSON.parse(box.querySelector('[data-variants]').textContent);
    var form = box.querySelector('form');
    var idInput = box.querySelector('[data-variant-id]');
    var btn = box.querySelector('[data-add]');
    var label = box.querySelector('[data-add-label]');
    var msg = box.querySelector('[data-msg]');
    var root = box.closest('[data-product-root]') || box.parentNode;
    var priceEl = root.querySelector('[data-price]');
    var galleryScope = box.closest('.split') || document;
    var D = box.dataset;

    function current() {
      var sets = box.querySelectorAll('fieldset.opt');
      if (!sets.length) return variants[0];
      var sel = Array.prototype.map.call(sets, function (f) {
        var sel2 = f.querySelector('select'); if (sel2) return sel2.value; var c = f.querySelector('input:checked'); return c ? c.value : null;
      });
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0] || null;
    }

    function render(v) {
      msg.textContent = '';
      if (!v) { btn.disabled = true; label.textContent = D.lSold; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      label.textContent = v.available ? D.lAdd : D.lSold;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price, D.money) + '</s>' : '') +
          '<span class="price__now">' + money(v.price, D.money) + '</span>';
      }
      if (v.featured_media) {
        var g = galleryScope.querySelector('[data-gallery]');
        if (g) showMedia(g, v.featured_media.id);
      }
      if (D.updateUrl === 'true' && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    box.querySelectorAll('fieldset.opt input, fieldset.opt select').forEach(function (i) {
      i.addEventListener('change', function () { render(current()); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true; label.textContent = D.lAdding; msg.textContent = '';
      fetch(cfg.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.j.description || D.lError); }
          label.textContent = D.lAdded;
          msg.innerHTML = '<a href="' + cfg.cartUrl + '">' + D.lCart + '</a>';
          return updateCartCount();
        })
        .catch(function (err) { msg.textContent = err.message || D.lError; })
        .then(function () { setTimeout(function () { btn.disabled = false; label.textContent = D.lAdd; }, 1600); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initProduct);
  }
  boot();
  document.addEventListener('shopify:section:load', boot);

  // close mobile menu when a link is tapped
  document.querySelectorAll('.burger a').forEach(function (a) {
    a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.removeAttribute('open'); });
  });
})();

